'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PageRail = require('./PageRail');

var _PageRail2 = _interopRequireDefault(_PageRail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PageRail2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PageRail/index.js
// module id = 626
// module chunks = 11